import { useCallback, useState } from 'react';
import type { PensieveLevelRange, PensieveQuestionLevel } from '@deadpan/shared';
import { loadPensieveLevelRange, persistPensieveLevelRange } from '../utils/pensieveLevelRangeStorage';

export function usePersistedPensieveLevelRange() {
  const [range, setRangeState] = useState<PensieveLevelRange>(loadPensieveLevelRange);

  const setMin = useCallback((min: PensieveQuestionLevel) => {
    setRangeState((prev: PensieveLevelRange) => {
      const next: PensieveLevelRange = {
        min,
        max: Math.max(min, prev.max) as PensieveQuestionLevel,
      };
      persistPensieveLevelRange(next);
      return next;
    });
  }, []);

  const setMax = useCallback((max: PensieveQuestionLevel) => {
    setRangeState((prev: PensieveLevelRange) => {
      const next: PensieveLevelRange = {
        min: Math.min(prev.min, max) as PensieveQuestionLevel,
        max,
      };
      persistPensieveLevelRange(next);
      return next;
    });
  }, []);

  return { range, setMin, setMax };
}
